// extracted by mini-css-extract-plugin
export default {"sheen":"tilt_sheen__RqbFW"};